<template>
  <div v-if="loading"  class="mt-220 d-flex justify-content-center align-items-center">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div class="mt-80" v-else>
    <div class="video-blocks"
         :class="[getVideo.length%2 === 0 ? 'justify-content-center' : 'justify-content-between']">
      <div
        class="video-block"
        v-for="(item, id) in videosArray"
        :key="id"
        >
        <div class="embed-responsive embed-responsive-16by9 mb-3">
          <iframe class="embed-responsive-item" :src="item.link +'?rel=0'" allowfullscreen></iframe>
        </div>
        <h1 class="video-title mx-0 my-0">{{item.title}}</h1>
        <pre><p class="video-discription textWrap">{{item.discription | truncate(100)}}</p></pre>
      </div>
    </div>
    <div class="mt-4 mb-5">
      <b-pagination-nav :link-gen="linkGen" :number-of-pages="pagination" align="center" use-router></b-pagination-nav>
    </div>
    <articles/>
    <Footer/>
  </div>
</template>

<script>
  import Articles from '@/views/Home/components/Articles';
  import Footer from '@/views/Home/components/Footer';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

  export default {
    name: "Video",
    metaInfo: {
      title: `Видео`
    },
    components: {Articles, Footer},
    data() {
      return {
        allVideosArr: [],
        videosArray: [],
        loading: true,
        pages: null
      }
    },
    beforeRouteEnter(to, from, next) {
      if (!to.query.page) next({ ...to, query: { page: 1, ...to.query } });
      else next();
    },
    props: ['props'],
    async mounted() {
      this.loading = true
      await this.getVideosLength()
      const response = await this.fetchVideos()
      await this.setVideos(response.reverse())
      this.loading = false
      this.allVideosArr = this.getVideo.reduce(function(result, value, index, array) {
        if (index % 4 === 0)
          result.push(array.slice(index, index + 4));
        return result;
      }, []);
      this.videosArray = this.allVideosArr[0]
      this.pages = this.allVideosArr.length
    },
    computed: {
      ...mapGetters('video', ['getVideo']),
      ...mapState('video', ['pagination'])
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + ' ...';
        }
        return value
      },
    },
    watch: {
      "$route.query.page": function (v) {
        if(v === undefined) {
          this.videosArray = this.allVideosArr[0]
        } else this.videosArray = this.allVideosArr[v-1]
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 300)
      }
    },
    methods: {
      ...mapMutations('video', ['setVideos']),
      ...mapActions('video', ['fetchVideos', 'getVideosLength']),
      linkGen(pageNum) {
        return pageNum === 1 ? '?page=1' : `?page=${pageNum}`
      },
    }
  }
</script>

<style lang="scss">
  .mt-220 {
    margin-top: 220px;
  }
  .video-blocks {
    padding: 104px 220px 55px;
    display: flex;
    flex-wrap: wrap;
    font-family: 'Raleway', sans-serif;
    .video-block {
      width: 45%;
      display: block;
      margin-right: 50px;
      pre {
        margin-bottom: 0;
      }
      .video-title {
        font-size: 17px;
        font-weight: 600;
        color: #1f1f1f;
      }
      .video-discription {
        font-size: 17px;
        line-height: 1.71;
        font-family: 'Raleway', sans-serif;
        color: #1f1f1f;
        margin-top: 16px;
        margin-bottom: 32px;
      }
    }
    .video-block:nth-child(2n + 2) {
      margin-right: 0;
    }
  }
  @media screen and (max-width: 1350px){
    .video-blocks {
      padding: 55px;
    }
  }
  @media screen and (max-width: 922px){
    .video-blocks {
      padding: 55px 24px;
    }
  }
  @media screen and (max-width: 800px){
    .video-blocks {
      padding: 55px 55px 0;
      justify-content: center !important;
      .video-block {
        width: 100%;
        margin-right: 0;
      }
    }
  }
  @media screen and (max-width: 568px){
    .video-blocks {
      padding: 55px 16px 0;
      justify-content: center !important;
      .video-block {
        width: 100%;
        margin-right: 0;
      }
    }
  }
</style>